/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';

import type { SearchResult, SearchSuggestionResult } from './search.types';

export async function getSearchResults(params: URLSearchParams, signal?: AbortSignal) {
    return axios
        .get<SearchResult>('/api/search/geo', { params, signal })
        .then(({ data }) => data);
}

export async function getSearchSuggestions(query: string, signal?: AbortSignal) {
    return axios
        .get<SearchSuggestionResult>('/api/search/suggest', {
            params: { q: query, geocoder: 'true' },
            signal,
        })
        .then(({ data }) => data);
}
